export default "__VITE_ASSET__9MjfFUq4__"